import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SuccessfulCreateLockComponent } from './successful-create-lock.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@NgModule({
  declarations: [SuccessfulCreateLockComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    FormsModule,
    MatButtonModule,
    TranslateModule
  ],
  exports: [SuccessfulCreateLockComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],

})
export class SuccessfulCreateLockModule {}
